function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi:            ["error", "never"]*/

/* eslint arrow-parens:    ["error", "as-needed"]*/

/* eslint key-spacing:     ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Button from '@engine/components/presentational/base/button';
import { Component } from 'react';
import Error from '@engine/components/presentational/base/error';
import Loader from '@engine/components/presentational/base/loader';
import Panel from '@engine/components/presentational/base/panel';
import ReminderSettings from '@engine/components/presentational/merchant-reminders-config/reminder-settings';
import SectionHeading from '@engine/components/presentational/base/section-heading';
import { connect } from 'react-redux';
import { ordinal } from '@engine/lib/utility/ordinal';
import { saveMerchantRemindersConfig } from '@engine/actions/creators/merchant-reminders-config';

var MerchantRemindersConfig = /*#__PURE__*/function (_Component) {
  _inherits(MerchantRemindersConfig, _Component);

  var _super = _createSuper(MerchantRemindersConfig);

  function MerchantRemindersConfig(props) {
    var _this;

    _classCallCheck(this, MerchantRemindersConfig);

    _this = _super.call(this, props);

    _this.handleReminderSettingChange = function (name, value) {
      _this.setState({
        remindersSettings: _objectSpread(_objectSpread({}, _this.state.remindersSettings), {}, _defineProperty({}, name, value))
      });
    };

    _this.handleRemainderCountChange = function (event) {
      var value = event.target.value;

      _this.setState({
        remindersCount: value
      });
    };

    _this.state = {
      remindersCount: props.remindersCount,
      remindersSettings: props.remindersSettings
    };
    return _this;
  }

  _createClass(MerchantRemindersConfig, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          remindersCount = _this$state.remindersCount,
          remindersSettings = _this$state.remindersSettings;
      var _this$props = this.props,
          maxRemindersAllowed = _this$props.maxRemindersAllowed,
          method = _this$props.method;
      return React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-md-6 col-lg-7"
      }, this.errorMessage(), React.createElement("div", {
        className: "form-horizontal"
      }, React.createElement(Panel.Container, null, React.createElement(Panel.Body, null, React.createElement(SectionHeading, {
        heading: method === 'PUT' ? I18n.t('javascript.reminders_configs.edit.edit_configuration') : I18n.t('javascript.reminders_configs.new.configuration')
      }), React.createElement("div", {
        className: "form-group"
      }, React.createElement("label", {
        className: "col-lg-12 col-xl-10 col-xl-offset-1"
      }, I18n.t('javascript.reminders_configs.form.reminders_count')), React.createElement("div", {
        className: "col-lg-12 col-xl-10 col-xl-offset-1"
      }, React.createElement("input", {
        type: "number",
        className: "form-control",
        min: "0",
        max: "3",
        placeholder: I18n.t('javascript.reminders_configs.form.count_placeholder'),
        value: remindersCount,
        onChange: this.handleRemainderCountChange,
        name: "reminders_config[reminders_settings][reminders_count]"
      }))), React.createElement(ReminderSettings, {
        remindersCount: remindersCount,
        remindersSettings: remindersSettings,
        maxRemindersAllowed: maxRemindersAllowed,
        onChange: this.handleReminderSettingChange
      })), React.createElement(Panel.Footer, null, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-lg-4 col-lg-offset-4"
      }, !this.props.isSaving && !this.props.isSaved && React.createElement(Button, {
        type: "success",
        className: "btn-block",
        onClick: function onClick() {
          return _this2.handleSubmit();
        }
      }, I18n.t('shared.actions.save')), this.props.isSaving && React.createElement(Loader, {
        position: "horizontal-center",
        color: "refined-blue"
      }), this.props.isSaved && !this.props.hasError && React.createElement(Loader, {
        position: "horizontal-center",
        color: "refined-green",
        icon: "ok"
      }), this.props.isSaved && this.redirect())))))));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;

      var _this$state2 = this.state,
          remindersSettings = _this$state2.remindersSettings,
          remindersCount = _this$state2.remindersCount;
      var updatedRemindersSettings = {};
      var count = parseInt(remindersCount, 10);

      for (var i = 1; i <= count; i += 1) {
        updatedRemindersSettings["".concat(ordinal(i), "_after")] = remindersSettings["".concat(ordinal(i), "_after")];
        updatedRemindersSettings["".concat(ordinal(i), "_channel")] = remindersSettings["".concat(ordinal(i), "_channel")];
      }

      this.setState({
        remindersSettings: updatedRemindersSettings
      }, function () {
        var data = _objectSpread(_objectSpread({}, updatedRemindersSettings), {}, {
          reminders_count: remindersCount
        });

        _this3.props.saveMerchantRemindersConfig(_this3.props.url, data, _this3.props.method);
      });
    }
  }, {
    key: "errorMessage",
    value: function errorMessage() {
      if (this.props.hasError) {
        return React.createElement(Error, null, React.createElement("ul", null, this.props.errors.map(function (key) {
          return React.createElement("li", {
            key: key
          }, key);
        })));
      }
    }
  }, {
    key: "redirect",
    value: function redirect() {
      if (this.props.hasError) {
        return;
      }

      window.location.replace(this.props.redirectUrl);
    }
  }]);

  return MerchantRemindersConfig;
}(Component);

MerchantRemindersConfig.defaultProps = {
  remindersCount: '',
  remindersSettings: {}
};
export default connect(function (state) {
  return {
    errors: state.merchantRemindersConfig.errors,
    hasError: state.merchantRemindersConfig.hasError,
    isSaved: state.merchantRemindersConfig.isSaved,
    isSaving: state.merchantRemindersConfig.isSaving
  };
}, {
  saveMerchantRemindersConfig: saveMerchantRemindersConfig
})(MerchantRemindersConfig);